import { ActionType } from '../../../stores/action-types';
import Button from '@material-ui/core/Button';
import Card from '../../../../components/Card/CardTS';
import CardBody from '../../../../components/Card/CardBody.js';
import CardHeader from '../../../../components/Card/CardHeader.js';
import CardIcon from '../../../../components/Card/CardIcon.js';
import React, { useCallback, ChangeEvent } from 'react';
import regularFormsStyle from '../../../../assets/jss/material-dashboard-pro-react/views/regularFormsStyleTS';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import { addAccount } from '../../../stores/actions/installerActions';
import { connect } from 'react-redux';
import Loading from '../../../components/Loading/Loading';
import Snackbar from '../../../../components/Snackbar/Snackbar';
import Person from '@material-ui/icons/Person';
import utils from '../../../helpers/GlobalVariables';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import _ from 'lodash';
import Chip from '@material-ui/core/Chip';
import FormControl from '@material-ui/core/FormControl';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { FormLabel } from '@material-ui/core';
import { createStyles, makeStyles, useTheme } from '@material-ui/core/styles';

import '../InstallerPanel.css';
import { Account, ISystem } from '../../../helpers/interfaces.js';

interface ICreateUserFormProps {
    accounts: Account[];
	systems: ISystem[];
	disableCreateAccountButton: boolean;
	createAccountFailed: boolean;
	createAccountSucceeded: boolean;
	mobileView: boolean;
	classes: ClassNameMap;
	accountCategory: string;
	addAccount: (name: string, email: string, phone: string, password: string, pickedSystems: number[], accountTypes: object, notifs: object) => void;
}

const CreateUserForm = ({
    accounts,
	systems,
	createAccountFailed,
	createAccountSucceeded,
	addAccount,
	disableCreateAccountButton,
	mobileView,
	accountCategory,
	...props
}: ICreateUserFormProps) => {
	const { classes } = props;
	const dispatch = useDispatch();
	const theme = useTheme();
	const closeNotificationTimer = useRef(null);
	const closeInvalidUserTimer = useRef(null);

    const getStyles = (name, personName, theme) => {
        return {
            fontWeight:
                personName.indexOf(name) === -1
                    ? theme.typography.fontWeightRegular
                    : theme.typography.fontWeightMedium,
        };
    };

    const [phoneExists, setPhoneExists] = useState(false);
    const [emailExists, setEmailExists] = useState(false);
    const notificationGroups = ['System', 'Heartbeat', 'L1', 'L2', 'L3', 'L4', 'Obstruction'];

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState(null);
    const [password, setPassword] = useState("");

    const [nameError, setNameError] = useState(false);
    const [emailError, setEmailError] = useState(false);
    const [phoneError, setPhoneError] = useState(false);
    const [passwordError, setPasswordError] = useState(false);
	const [pickedSystems, setPickedSystems] = useState<number[]|null[]|undefined>([]);

	const filteredSystems = _.filter([...systems], (system) => 
		['administrator', 'installer'].includes(system.accountRole));
	const sortedSystems = [...filteredSystems].sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : -1);
	const systemIds = sortedSystems.map(el => el.ID);
    const [systemOptions, setSystemOptions] = useState(systemIds);
    const systemNamesByIds = Object.fromEntries(sortedSystems.map(x => [x.ID, x.name]));

    const [emailNotifs, setEmailNotifs] = useState({});
    const [pushNotifs, setPushNotifs] = useState({});
    const [smsNotifs, setSmsNotifs] = useState({});

    const [accountRoles, setAccountRoles] = useState({});
	console.log('CreateUser, sortedSystems', sortedSystems);

	const closeCreateAccountNotification = useCallback(() => {
		dispatch({ type: ActionType.CLOSE_CREATE_ACCOUNT_NOTIFICATION });
	}, [dispatch]);

	useEffect(() => {
		closeCreateAccountNotification();
        setEmailExists(false);
        setPhoneExists(false);
	}, [closeCreateAccountNotification, setEmailExists, setPhoneExists]);

	useEffect(() => {
		if (createAccountFailed || createAccountSucceeded) {
			if (createAccountSucceeded) {
				setName("");
				setPassword("");
				setEmail("");
				setPhone(null);
				setPickedSystems([]);
			}
			closeNotificationTimer.current = setTimeout(closeCreateAccountNotification, 6000);
		}
		return () => {
			clearTimeout(closeNotificationTimer.current);
		};

	}, [closeCreateAccountNotification, createAccountFailed, createAccountSucceeded]);

	useEffect(() => {
		if (phoneExists || emailExists) {
			closeInvalidUserTimer.current = setTimeout(() => {
                setEmailExists(false);
                setPhoneExists(false);
			}, 6000);

			return () => {
				clearTimeout(closeInvalidUserTimer.current);
			};
		}
	}, [phoneExists, emailExists]);

	useEffect(() => {
        let roles = {};
        pickedSystems?.forEach(sys => {
            roles[sys] = accountRoles[sys] ?? 'common_user';
        });
        setAccountRoles(roles);
    }, [pickedSystems]);

	const handleAddAccount = (): void => {
		closeCreateAccountNotification();
        const emailExists = _.filter(accounts, {email: email})?.length;
        const phoneExists = phone && _.some(accounts, acc => acc.phone?.String === phone);
        console.log('accounts', accounts);
        if (emailExists) {
            setEmailExists(true);
        } else if (phoneExists) {
            setPhoneExists(true);
        } else {
            addAccount(name, email, phone, password, pickedSystems, accountRoles, {email: emailNotifs, push: pushNotifs, sms: smsNotifs});
        }
		
	};

	const onCreateAccountButtonClick = (): JSX.Element => {
		if (disableCreateAccountButton) {
			return (
				<div style={{ marginTop: '25px', marginBottom: '10px', paddingLeft: '10px', paddingTop: '5px' }}>
					<Loading transform={1} height={17} width={40} color='darkGray' />
				</div>
			);
		}

		return (
			<Button
				size='medium'
				style={{ marginTop: nameError || emailError || phoneError || passwordError ? '5px' : '25px', transition: 'color 0.3s' }}
				disabled={
					nameError ||
                    emailError ||
                    phoneError ||
                    passwordError ||
					!name.length ||
                    !email.length ||
                    !password.length ||
					!pickedSystems ||
					!pickedSystems.length ||
					createAccountFailed ||
					createAccountSucceeded ||
					phoneExists  ||
                    emailExists

				}
				onClick={() => handleAddAccount()}
			>
				Create
			</Button>
		);
	};

	const renderMobileNotifications = (): JSX.Element => {
		const error = createAccountFailed || emailExists || phoneExists;
		const headerStyle = utils.getHeaderStyle(error);

		if (!mobileView) return null;
		if (error || createAccountSucceeded) {
			const className = error ? 'notification-open-create-account-fail' : 'notification-open-create-account-success';
			return (
				<h5 className={className} style={headerStyle}>
					{createAccountFailed
						? 'Could not create user.'
						: emailExists
							? "User with specified e-mail already exists."
                            : phoneExists
                                ? "User with specified phone number already exists."
                                : 'User was created successfully.'
					}
				</h5>
			);
		}
		return <div style={utils.emptyHeaderStyle}></div>;
	};
    
    const verifyName = (name) => {
        return name.length > 2;
    }

    const verifyEmail = (email) => {
        //RFC 2821 standard for email validation:
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return email.match(emailRegex);
    };
    
    const verifyPhone = (phone) => {
        const phoneRex = /^\+\d{11,13}$/;
        return phone.match(phoneRex);
    };

    const verifyPassword = (password) => {
        return password.length > 7;
    }

    const checkInvalidCharacters = (str) => {
        const invalidCharacters = [
          "<",
          ">",
          "&lt;",
          "&gt;",
          "&#60;",
          "&#62;",
          "/",
          "&#47;",
          "\\",
          "&#92;",
          "&",
          "&amp;",
          "&#38;",
          ";",
        ];
        const containesChar = (char) => str.includes(char);
        const isIncorrectValue = invalidCharacters.some(containesChar);
        if (!str ||isIncorrectValue) {
          return true;
        }
        return false;
      };
    
    const change = (event, setter, errorSetter, type) => {
        const val = event.target.value;
        switch (type) {
            case "name":
                errorSetter(!verifyName(val) || checkInvalidCharacters(val));
                break;
            case "email":
                errorSetter(!verifyEmail(val) || checkInvalidCharacters(val));
                break;
            case "phone":
                errorSetter(val && (!verifyPhone(val) || checkInvalidCharacters(val)));
                break;
            case "password":
                errorSetter(!verifyPassword(val));
            default:
                break;
        }
        setter(!val ? null : val);
    }

	const renderNotificationSettings = () => {
        if (!pickedSystems?.length) return null;

        const pickedSystemObjs = _.filter(sortedSystems, function (s) { return pickedSystems.includes(s.ID)});
        return (<div style={{ display: 'flex', flexDirection: 'column', marginTop: '20px', marginBottom: '20px' }}>
            <FormLabel style={{marginBottom: '15px', marginTop: '15px'}}>{'Notifications'}</FormLabel>
            { 
                pickedSystemObjs.map(sys => {
                    if (sys.systemVersion == 'W2') {
                        return  (
                        <div key={sys.ID} style={{ display: 'flex', alignItems: 'baseline' }}>                        
                            <div style={{ display: 'flex', flexDirection: mobileView ? 'column' : 'row', marginTop: mobileView ? '25px' : '0px', alignItems: 'baseline' }}>
                            <div style={{display: 'flex', width: mobileView ? '100%' : '300px'}}>{systemNamesByIds[sys.ID]}</div>
                              <div style={{display: 'flex', color: 'grey', marginTop: '16px'}}> W2 System can't be edited here. Go to the W2 System Settings panel. </div>
                            </div>
                        </div>)
                    }
                    return (
                    <div key={sys.ID} style={{ display: 'flex', alignItems: 'baseline' }}>
                        
                        <div style={{ display: 'flex', flexDirection: mobileView ? 'column' : 'row', marginTop: mobileView ? '25px' : '0px', alignItems: 'baseline', width: '100%' }}>
                        <div style={{display: 'flex', width: mobileView ? '100%' : '300px'}}>{systemNamesByIds[sys.ID]}</div>
                        <FormControl id='push-multi-chip-label' style={{minWidth: mobileView ? '10px' : '25%'}}>
                            <InputLabel id='push-multi-chip-label'>Email</InputLabel>
                            <Select
                                label='email-multi-chip-label-'
                                id='email-multi-chip'
                                multiple
                                // style={{maxWidth: mobileView ? '10px' : '250px', minWidth: mobileView ? '10px' : '50%'}}
                                value={emailNotifs[sys.ID] ?? []}
                                onChange={(e) => {
                                    setEmailNotifs(prevNotifs => {
                                        const newNotifs = { ...prevNotifs, [sys.ID]: e.target.value };
                                        return newNotifs;
                                    });
                                }}
                                input={<Input id='select-multiple-chip-' />}
                                renderValue={(selected) => (
                                    <div className={classes.chips}>
                                        {(selected as string[]).map((value) => (
                                            <Chip key={value} label={value} className={classes.chip} />
                                        ))}
                                    </div>
                                )}
                            >
                                {notificationGroups.map((name, i) => (
                                    <MenuItem
                                        key={`name-${i}`}
                                        value={name}
                                        style={getStyles(name, 'email', theme)}
                                    >
                                        {name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <FormControl id='push-multi-chip-label2' style={{minWidth: mobileView ? '10px' : '25%', marginLeft: mobileView ? '0px' : '10px'}}>
                            <InputLabel id='push-multi-chip-label2'>Push</InputLabel>
                            <Select
                                label='push-multi-chip-label-'
                                id='push-multi-chip'
                                multiple
                                // style={{marginLeft: mobileView ? '0px' : '10px'}}
                                value={pushNotifs[sys.ID] ?? []}
                                disabled={sys.systemVersion == 'W2'}
                                onChange={(e) => {
                                    setPushNotifs(prevNotifs => {
                                        const newNotifs = { ...prevNotifs, [sys.ID]: e.target.value };
                                        return newNotifs;
                                    });
                                }}
                                input={<Input id='select-multiple-chip-2' />}
                                renderValue={(selected) => (
                                    <div className={classes.chips}>
                                        {(selected as string[]).map((value) => (
                                            <Chip key={value} label={value} className={classes.chip} />
                                        ))}
                                    </div>
                                )}
                            >
                                {notificationGroups.map((name, i) => (
                                    <MenuItem
                                        key={`name-${i}`}
                                        value={name}
                                        style={getStyles(name, 'push', theme)}
                                    >
                                        {name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl id='sms-multi-chip-label3' style={{minWidth: mobileView ? '10px' : '25%', marginLeft: mobileView ? '0px' : '10px'}}>
                            <InputLabel id='sms-multi-chip-label2'>SMS</InputLabel>
                            <Select
                                label='sms-multi-chip-label-'
                                id='sms-multi-chip'
                                multiple
                                value={smsNotifs[sys.ID] ?? []}
                                disabled={sys.systemVersion == 'W2'}
                                onChange={(e) => {
                                    setSmsNotifs(prevNotifs => {
                                        const newNotifs = { ...prevNotifs, [sys.ID]: e.target.value };
                                        return newNotifs;
                                    });
                                }}
                                input={<Input id='select-multiple-chip-2' />}
                                renderValue={(selected) => (
                                    <div className={classes.chips}>
                                        {(selected as string[]).map((value) => (
                                            <Chip key={value} label={value} className={classes.chip} />
                                        ))}
                                    </div>
                                )}
                            >
                                {notificationGroups.map((name, i) => (
                                    <MenuItem
                                        key={`name-${i}`}
                                        value={name}
                                        style={getStyles(name, 'sms', theme)}
                                    >
                                        {name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        </div>
                    </div>
                    )
                })
            }
        
        </div>)
    }

    const renderAccountRoleSettings = () => {
        if (!pickedSystems?.length || accountCategory == 'commoner') return null;

        const pickedSystemObjs = _.filter(sortedSystems, function (s) { return pickedSystems.includes(s.ID)});
        return (<div style={{ display: 'flex', flexDirection: 'column', marginTop: '20px', marginBottom: '20px', minWidth: mobileView ? '10px' : '25%' }}>
            <FormLabel style={{marginBottom: '15px', marginTop: '15px'}}>{'Account type'}</FormLabel>
            { 
                pickedSystemObjs.map(sys => {
                    return (
                    <div key={sys.ID} style={{ display: 'flex', alignItems: 'baseline' }}>
                        
                        <div style={{ display: 'flex', flexDirection: mobileView ? 'column' : 'row', marginTop: mobileView ? '25px' : '0px', alignItems: 'baseline' }}>
                        <div style={{display: 'flex', width: mobileView ? '100%' : '300px'}}>{systemNamesByIds[sys.ID]}</div>
                        <RadioGroup
                            row
                            aria-labelledby="demo-form-control-label-placement"
                            name="position"
                            defaultValue="common_user"
                        >

                            <FormControlLabel
                                value="common_user"
                                control={<Radio onChange={(e) => {
                                    setAccountRoles(prevRoles => {
                                        const newRoles = { ...prevRoles, [sys.ID]: e.target.value };
                                        return newRoles;
                                    });
                                }} />}
                                label="User"
                                labelPlacement="start"
                            />
                            <FormControlLabel
                                value="administrator"
                                control={<Radio onChange={(e) => {
                                    setAccountRoles(prevRoles => {
                                        const newRoles = { ...prevRoles, [sys.ID]: e.target.value };
                                        return newRoles;
                                    });
                                }} />}
                                label="Admin"
                                labelPlacement="start"
                            />

                        </RadioGroup>
                        </div>
                    </div>
                    )
                })
            }
        
        </div>)
    }

    if (systems.length < 1) {
        return (
            <Card>
                <CardHeader color='info' icon>
                    <CardIcon color='info'>
                        <Person />
                    </CardIcon>
                    <h4 className={classes.cardIconTitle}>
                        Create User
                    </h4>
                </CardHeader>
                <CardBody>This feature is unavailable for your account.</CardBody>
            </Card>
        );
    }

	return (
		<Card className='createUserForm'>
			<CardHeader color='info' icon>
				<CardIcon color='info'>
					<Person />
				</CardIcon>
				<h4 className={classes.cardIconTitle}>Create User</h4>
			</CardHeader>
			<CardBody>
				<FormControl fullWidth className={classes.selectFormControl} onSubmit={(e) => e.preventDefault()} disabled={!systems || !systems.length}>
					<div>
                        <TextField
							label='Name'
							id='name'
							inputProps={{ maxLength: 255, value: name ?? '', autoCapitalize: 'off' }}
							onChange={(e) => change(e, setName, setNameError, "name")}
							fullWidth={true}
							style={{ marginTop: '26px', marginBottom: '5px' }}
							error={nameError}
							helperText={nameError ? 'Invalid name' : ''}
						></TextField>
						<TextField
							label='E-mail'
							id='email'
							inputProps={{ maxLength: utils.defaultMaxEmailLength, value: email ?? '', autoCapitalize: 'off' }}
							onChange={(e) =>change(e, setEmail, setEmailError, "email")}
							fullWidth={true}
							style={{ marginTop: '26px', marginBottom: '5px' }}
							error={emailError}
							helperText={emailError ? 'Invalid email address' : ''}
						></TextField>
                        <TextField
							label='Phone number'
							id='phone-number'
							inputProps={{ maxLength: utils.defaultMaxEmailLength, value: phone ?? '', autoCapitalize: 'off' }}
							onChange={(e) => change(e, setPhone, setPhoneError, "phone")}
							fullWidth={true}
							style={{ marginTop: '26px', marginBottom: '5px' }}
							error={phoneError}
							helperText={phoneError ? 'Invalid phone number' : ''}
						></TextField>
                        <TextField
							label='Password'
							id='password'
							inputProps={{ maxLength: utils.defaultMaxEmailLength, value: password ?? '', autoCapitalize: 'off' }}
							onChange={(e) => change(e, setPassword, setPasswordError, "password")}
							fullWidth={true}
							style={{ marginTop: '26px', marginBottom: '5px' }}
							error={passwordError}
							helperText={passwordError ? 'Password too short' : ''}
						></TextField>
						<Autocomplete
                            options={systemOptions}
                            getOptionLabel={(id) => systemNamesByIds[id]}
                            id='system-name'
                            value={pickedSystems}
                            multiple={true}
                            onChange={(e, newVal) => setPickedSystems(newVal)}
                            renderInput={(systemOptions) => <TextField {...systemOptions} label='Systems' margin='normal' />}
                            style={{ width: '100%' }}
                        />
						{renderNotificationSettings()}
						{renderAccountRoleSettings()}
					</div>
				</FormControl>
				{renderMobileNotifications()}
				{onCreateAccountButtonClick()}
			</CardBody>
			{!mobileView ? (
				<>
					<Snackbar
						close
						closeNotification={() => closeCreateAccountNotification()}
						color={createAccountFailed ? 'danger' : 'success'}
						message={createAccountFailed ? 'Could not create user.' : 'User was created successfully.'}
						open={createAccountFailed || createAccountSucceeded}
						place='tc'
					/>
					<Snackbar
						close
						closeNotification={() => setEmailExists(false)}
						color='danger'
						message="User with specified e-mail already exists."
						open={emailExists}
						place='tc'
					/>
					<Snackbar
						close
						closeNotification={() => setPhoneExists(false)}
						color='danger'
						message="User with specified phone number already exists."
						open={phoneExists}
						place='tc'
					/>
				</>
			) : null}
		</Card>
	);
};

const mapStateToProps = (state, ownProps) => ({
	disableCreateAccountButton: state.dashboard.disableCreateAccountButton,
	createAccountFailed: state.dashboard.createAccountFailed,
	systems: ownProps.systems || state.installer.systemsForInstallerPanel || [],
	createAccountSucceeded: state.dashboard.createAccountSucceeded,
	mobileView: state.dashboard.mobileView
});
const actions = { addAccount };

const CreateUserFormWithStyles = regularFormsStyle(CreateUserForm);
export default connect(mapStateToProps, actions)(CreateUserFormWithStyles);
